import { put, call } from 'redux-saga/effects';
import { dataCenterCreateAPI, dataCenterListAPI, fileHistoryAPI, fileRecordsAPI, getFileHeadersAPI, saveFileHeaderAPI, uploadFileFromSheetsAPI } from 'src/api/DataCenterApi';
import { DATA_CENTER_ACTIONS, DATA_CENTER_FILE_HEADERS, DATA_CENTER_FILE_REQUEST, FILE_HISTORY_ACTIONS, FILE_RECORDS_ACTIONS } from '../actions/DataCenterActionTypes';
import { toast } from 'react-toastify';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { fileUploadError, fileUploadSuccess, getFileHeadersError, getFileHeadersSuccess, updateColumnVisibilityError, updateColumnVisibilitySuccess } from '../actions/DataCenterActions';

function* createDataCenter({ payload }) {
    try {
        const { data } = yield call(dataCenterCreateAPI, payload);

        yield put({
            type: DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_SUCCESS,
            data,
        });
        yield put({
            type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST,
        });
        toast.success("Data Center Created Successfully!");
    } catch (error) {
        console.error('Error creating data center:', error);

        yield put({
            type: DATA_CENTER_ACTIONS.DATA_CENTER_CREATE_ERROR,
        });

        toast.error("Error creating data center.");
    }
}

function* fetchDataCenterList() {
    try {
        const { data } = yield call(dataCenterListAPI);

        yield put({
            type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST_SUCCESS,
            data: data?.data?.data,
            totalRows: data?.data?.totalRows
        });

        // toast.success("Data Centers fetched successfully!");
    } catch (error) {
        console.error('Error fetching data centers:', error);

        yield put({
            type: DATA_CENTER_ACTIONS.DATA_CENTER_LIST_ERROR,
        });

        toast.error("Error fetching data centers.");
    }
}

function* fetchFileHistory(action) {
    try {
        const { payload } = action;
        const { data } = yield call(fileHistoryAPI, payload.data);

        yield put({
            type: FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_SUCCESS,
            payload: {
                data: data?.data
            }
        });

        // toast.success("File history fetched successfully!");
    } catch (error) {
        console.error('Error fetching file history:', error);

        yield put({
            type: FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_ERROR,
        });

        toast.error("Error fetching file history.");
    }
}

function* dataCenterFileUploadSaga(action) {
    try {
        const firstApiResponse = yield call(saveFileHeaderAPI, action.payload);
        if (firstApiResponse?.data?.success) {

            const uploadPayload = {
                ...action.payload,
                headerId: firstApiResponse?.data?.data?.headers?._id
            };
            const response = yield call(uploadFileFromSheetsAPI, uploadPayload);
            yield put(fileUploadSuccess(response));

            yield call(fetchFileRecords, {
                payload: {
                    fileId: response.data.dataCenterId,
                    ...action.payload
                }
            });
        } else {
            throw new Error('File upload failed.');
        }

    } catch (error) {
        yield put(fileUploadError(error.message || 'File upload failed.'));
    }
}

function* fetchFileHeadersSaga(action) {
    try {
        const response = yield call(getFileHeadersAPI, action.payload);
        yield put(getFileHeadersSuccess(response?.data?.data?.headers));
    } catch (error) {
        yield put(getFileHeadersError(error.message || 'Failed to fetch file headers'));
    }
}

function* fetchFileRecords(action) {
    try {
        const response = yield call(fileRecordsAPI, action.payload);

        if (!response?.data?.data) {
            throw new Error('Invalid response structure from server');
        }

        const {
            records = [],
            columns = [],
            headerId = null,
            totalRecords = 0
        } = response.data.data;

        const processedColumns = columns.map(column => ({
            ...column,
            visible: true,
        }));

        yield put({
            type: FILE_RECORDS_ACTIONS.FILE_RECORDS_SUCCESS,
            payload: {
                data: records,
                columns: processedColumns,
                headerId,
                totalRecords,
                currentPage: action.payload.currentPage || 0,
                pageSize: action.payload.pageLength || 10000
            }
        });

        toast.success("File records fetched successfully!");
    } catch (error) {
        console.error('Error fetching file records:', error);

        const errorMessage = error.response?.data?.message
            || error.message
            || 'Error fetching file records';

        yield put({
            type: FILE_RECORDS_ACTIONS.FILE_RECORDS_ERROR,
            payload: errorMessage,
        });

        toast.error(errorMessage);
    }
}

function* updateColumnVisibilitySaga(action) {
    try {
        const updatedColumns = action.payload;
        yield put(updateColumnVisibilitySuccess(updatedColumns));
    } catch (error) {
        yield put(updateColumnVisibilityError(error.message));
    }
}

export default [
    takeFirstSagaUtil(DATA_CENTER_ACTIONS.DATA_CENTER_CREATE, createDataCenter),
    takeFirstSagaUtil(DATA_CENTER_ACTIONS.DATA_CENTER_LIST, fetchDataCenterList),
    takeFirstSagaUtil(FILE_HISTORY_ACTIONS.FILE_HISTORY_LIST_REQUEST, fetchFileHistory),
    takeFirstSagaUtil(DATA_CENTER_FILE_REQUEST.FILE_UPLOAD_REQUEST, dataCenterFileUploadSaga),
    takeFirstSagaUtil(DATA_CENTER_FILE_HEADERS.FILE_HEADERS_REQUEST, fetchFileHeadersSaga),
    takeFirstSagaUtil(FILE_RECORDS_ACTIONS.FILE_RECORDS_REQUEST, fetchFileRecords),
    takeFirstSagaUtil(DATA_CENTER_FILE_HEADERS.UPDATE_COLUMN_VISIBILITY_REQUEST, updateColumnVisibilitySaga),
];